import { render, staticRenderFns } from "./x-button.vue?vue&type=template&id=17b85f6a&scoped=true&"
import script from "./x-button.vue?vue&type=script&lang=js&"
export * from "./x-button.vue?vue&type=script&lang=js&"
import style0 from "./x-button.vue?vue&type=style&index=0&id=17b85f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b85f6a",
  null
  
)

export default component.exports